<template>
  <div class="user-info is-pulled-right">
    <div class="store-name">
      <div v-if="multiStore">
        <BDropdown position="is-bottom-left">
          <button slot="trigger" class="button is-primary is-small shop-selector">
            <span>{{ storeName }}</span>
            <i class="icon-caret-down" aria-hidden="true" />
          </button>
          <BDropdownItem v-for="store in stores" :key="store.store_id" @click="setCurrentStore(store)">
            {{ store.name }}
          </BDropdownItem>
        </BDropdown>
      </div>
      <span v-else>{{ storeName }}</span>
    </div>
    <BDropdown class="user" :mobileModal="false" position="is-bottom-left">
      <div slot="trigger">
        <span>{{ userEmail }}</span>
        <i class="icon is-small icon-angle-down" aria-hidden="true" />
      </div>
      <BDropdownItem @click="signOutAndMoveToSignIn"> Sign out </BDropdownItem>
    </BDropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters({
      currentStore: "user/getCurrentStore",
      stores: "user/getStores",
      userInfo: "user/getUserInfo",
    }),
    storeName() {
      return this.currentStore.name;
    },
    userEmail() {
      return this.userInfo.email;
    },
    multiStore() {
      return this.stores.length > 1;
    },
  },
  methods: {
    ...mapActions("user", ["signOut", "setCurrentStore"]),
    signOutAndMoveToSignIn() {
      this.signOut();
      this.$router.push({ name: "signIn" });
    },
  },
};
</script>

<style scoped lang="scss">
.user-info {
  display: flex;
  flex-direction: row;
  margin-top: 29px;
  margin-right: 29px;
  font-size: 13px;
}

.store-name {
  margin-right: 5px;
}

.user {
  color: $primary;
}

.icon {
  font-size: 10px;
}

.button.shop-selector {
  height: 20px;
  font-size: 8px;
}
</style>
